import React, { Component } from "react";
import { connect } from "react-redux";

import { TextField, Checkbox } from "./FormElements";
import { inArray, l } from "../functions";

import ListSortedItemsCheckboxes from "./ListSortedItemsCheckboxes";

const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    fetchedCategories: state.rootReducer.fetchedCategories || {},
  };
};

class ProductFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toFilter: [],
      filter: [],
    };
  }

  _setToFilter = (target) => {
    const { toFilter } = this.state;
    if (inArray(target, toFilter)) {
      const key = toFilter.findIndex((e) => e === target);
      toFilter.splice(key, 1);
    } else toFilter.push(target);

    this.setState({
      toFilter: toFilter,
    });
  };

  _setFilter = (target, value) => {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        [target]: value,
      },
    });
  };

  _filteredProducts = (product) => {
    const { filter } = this.state;

    for (let target of Object.keys(filter)) {
      if (
        typeof filter[target] === "string" &&
        !product[target].match(new RegExp(filter[target], "i"))
      )
        return false;

      if (
        typeof filter[target] === "object" &&
        Array.isArray(filter[target]) &&
        filter[target].filter((x) => product[target].includes(x)).length === 0
      )
        return false;
    }

    return true;
  };

  render() {
    const { toFilter, filter } = this.state;

    const { onCheck, list, multiple, label } = this.props;

    return (
      <div>
        <div className="section">
          <label className="small">{label || l("Filter")}</label>
          <ul className="inline-options dark grow">
            <li
              onClick={() => {
                this._setToFilter("name");
              }}
              className={inArray("name", toFilter) ? "selected" : ""}
            >
              <span>{l("By name")}</span>
            </li>
            <li
              onClick={() => {
                this._setToFilter("categories");
              }}
              className={inArray("categories", toFilter) ? "selected" : ""}
            >
              <span>{l("By category")}</span>
            </li>
          </ul>
        </div>
        {inArray("name", toFilter) && (
          <div className="section">
            <label className="small">{l("Filter by name")}</label>
            <TextField
              placeholder={l("Product name")}
              value={filter.name || ""}
              onChange={(value) => {
                this._setFilter("name", value);
              }}
              dark
            />
          </div>
        )}
        {inArray("categories", toFilter) && (
          <div className="section">
            <label className="small">{l("Filter by category")}</label>

            <ListSortedItemsCheckboxes
              list={filter.categories || []}
              onCheck={(list) => {
                this._setFilter("categories", list);
              }}
              items={this.props.fetchedCategories.leveled}
              inlineItems={this.props.fetchedCategories.normal}
              multiple
            />
          </div>
        )}
        <div className="section">
          <label className="small">{l("Filtered products")} :</label>

          <div className="category-items">
            {Object.keys(this.props.fetchedProducts).map((id_product, key) => {
              return (
                (((filter.name ||
                  (filter.categories && filter.categories.length > 0)) &&
                  this._filteredProducts(
                    this.props.fetchedProducts[id_product]
                  )) ||
                  inArray(id_product, list) ||
                  id_product === list) && (
                  <div key={key} className="category-item">
                    <div
                      className={`item pleft ${
                        ((multiple && inArray(id_product, list)) ||
                          id_product === list) &&
                        "selected"
                      }`}
                    >
                      <Checkbox
                        label={this.props.fetchedProducts[id_product].name}
                        size="small"
                        onChange={(checked) => {
                          let newList = list;

                          if (multiple) {
                            if (checked && !inArray(id_product, newList))
                              newList.push(id_product);

                            if (!checked && inArray(id_product, newList)) {
                              const key = newList.findIndex(
                                (e) => e === id_product
                              );
                              newList.splice(key, 1);
                            }
                          } else {
                            if (newList !== id_product) newList = [id_product];
                            else newList = [];
                          }

                          let finalList = [];

                          for (const productId of newList) {
                            if (this.props.fetchedProducts[productId])
                              finalList.push(productId);
                          }

                          onCheck(finalList);
                        }}
                        checked={
                          (multiple && inArray(id_product, list)) ||
                          id_product === list
                        }
                      />
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ProductFilter);
